function registerWidget (w, token) {
    w['_ekomiWidgetsServerUrl'] = 'https://widgets.ekomi.com';
    w['_customerId'] = 110350;
    
    if (w['_language'] == undefined) {
        w['_language'] = new Array();
    }
    w['_language'][token] = 'auto';     
    
    if(typeof(w['_ekomiWidgetTokens']) !== 'undefined'){
        w['_ekomiWidgetTokens'][w['_ekomiWidgetTokens'].length] = token;
    } else {
        w['_ekomiWidgetTokens'] = new Array(token);
    }
    if(typeof(ekomiWidgetJs) == 'undefined') {
        ekomiWidgetJs = true;
        var scr = document.createElement('script');scr.src = 'https://sw-assets.ekomiapps.de/static_resources/widget.js';
        var head = document.getElementsByTagName('head')[0];head.appendChild(scr);
        
    } else {if (typeof ekomiWidgetMain != 'undefined') {ekomiWidgetMain('ajax', token);}}
    return true;
}
(function (w) {
    var token = 'sf11035068d28d5e5ce05';
    var k = document.getElementsByClassName("ekomi-widget-" + token);
    for(var x=0;x<k.length;x++){ registerWidget(w,token); }
})(window);
(function (w) {
    var token = 'sf1103505c8659c76580d';
    var k = document.getElementsByClassName("ekomi-widget-" + token);
    for(var x=0;x<k.length;x++){ registerWidget(w,token); }
})(window);
(function (w) {
    var token = 'sf1103505f7f416910d9c';
    var k = document.getElementsByClassName("ekomi-widget-" + token);
    for(var x=0;x<k.length;x++){ registerWidget(w,token); }
})(window);
(function (w) {
    var token = 'sf1103505f7f41ff3c4b4';
    var k = document.getElementsByClassName("ekomi-widget-" + token);
    for(var x=0;x<k.length;x++){ registerWidget(w,token); }
})(window);
function registerWidget (w, token) {
    w['_ekomiWidgetsServerUrl'] = 'https://widgets.ekomi.com';
    w['_customerId'] = 110350;
    
    if (w['_language'] == undefined) {
        w['_language'] = new Array();
    }
    w['_language'][token] = 'auto';     
    
    if(typeof(w['_ekomiWidgetTokens']) !== 'undefined'){
        w['_ekomiWidgetTokens'][w['_ekomiWidgetTokens'].length] = token;
    } else {
        w['_ekomiWidgetTokens'] = new Array(token);
    }
    if(typeof(ekomiWidgetJs) == 'undefined') {
        ekomiWidgetJs = true;
        var scr = document.createElement('script');scr.src = 'https://sw-assets.ekomiapps.de/static_resources/widget.js';
        var head = document.getElementsByTagName('head')[0];head.appendChild(scr);
        
    } else {if (typeof ekomiWidgetMain != 'undefined') {ekomiWidgetMain('ajax', token);}}
    return true;
}
(function (w) {
    var token = 'sf11035068d29907dd13f';
    var k = document.getElementsByClassName("ekomi-widget-" + token);
    for(var x=0;x<k.length;x++){ registerWidget(w,token); }
})(window);